import { render, staticRenderFns } from "./toolbar-button-human-service.vue?vue&type=template&id=a5b73b90"
import script from "./toolbar-button-human-service.vue?vue&type=script&lang=ts"
export * from "./toolbar-button-human-service.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports